import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { billingKeys } from '../queries/keys';
import { billingPaths } from '../queries/paths';

// TSS vite/03 — tipos de manejo/pensión + su COMPOSICIÓN documental
// (management → cost × quantity, admin-billing-catalog.md · Capa 5). El `total`
// de la composición es informativo (NO es la tarifa que liquida — esa va aparte).
// Permisos: billing:read / billing:write.

function clean(filters = {}) {
    const out = {};
    for (const k of ['limit', 'offset', 'sort', 'status', 'q']) {
        const v = filters[k];
        if (v !== '' && v != null) out[k] = v;
    }
    return out;
}

export function useManagementsList(filters) {
    const params = clean(filters);
    return useQuery({
        queryKey: billingKeys.managements(params),
        queryFn:  ({ signal }) => api.get(billingPaths.managements(), { params, signal }).then(r => r.data),
        placeholderData: (prev) => prev,
    });
}

export function useCreateManagement() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post(billingPaths.managements(), payload).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: billingKeys.all }),
    });
}

export function useUpdateManagement(id) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.patch(billingPaths.management(id), payload).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: billingKeys.all }),
    });
}

export function useDeleteManagement() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => api.delete(billingPaths.management(id)).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: billingKeys.all }),
    });
}

// ---- composición (líneas) de un management ----

export function useManagementLines(id) {
    return useQuery({
        queryKey: billingKeys.lines(id),
        queryFn:  ({ signal }) => api.get(billingPaths.lines(id), { signal }).then(r => r.data),
        enabled:  !!id,
    });
}

export function useAddLine(id) {
    const qc = useQueryClient();
    return useMutation({
        // idempotente por (management, cost): re-agregar el mismo costo = UPDATE de la cantidad
        mutationFn: (payload) => api.post(billingPaths.lines(id), payload).then(r => r.data),
        onSuccess:  () => { qc.invalidateQueries({ queryKey: billingKeys.lines(id) }); qc.invalidateQueries({ queryKey: billingKeys.all }); },
    });
}

export function useUpdateLine(id) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ lineId, ...payload }) => api.patch(billingPaths.line(id, lineId), payload).then(r => r.data),
        onSuccess:  () => { qc.invalidateQueries({ queryKey: billingKeys.lines(id) }); qc.invalidateQueries({ queryKey: billingKeys.all }); },
    });
}

export function useDeleteLine(id) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (lineId) => api.delete(billingPaths.line(id, lineId)).then(r => r.data),
        onSuccess:  () => { qc.invalidateQueries({ queryKey: billingKeys.lines(id) }); qc.invalidateQueries({ queryKey: billingKeys.all }); },
    });
}
